module.exports = __webpack_public_path__ + "media/RaktenTVMobileHero.3e9c3527.png";